import { sideNavItemsExternal } from '../config/sideMenuNavItems';

export const termPaths = sideNavItemsExternal.reduce((acc, { link }) => {
  acc.push(link);
  return acc;
}, []);

export const termNames = sideNavItemsExternal.reduce((acc, { label }) => {
  acc.push(label);
  return acc;
}, []);
